import { AppState } from '../../rootReducer';
import { ChatScheduleJs, DateRange } from '../types';
import { getSchedulesForRange } from '../utils';

export const makeSelectShedulesForRange =
    (range: DateRange) =>
    (state: AppState): ChatScheduleJs[] =>
        getSchedulesForRange(state.chatScheduleReducer.chatSchedules, range).map((s) => ({
            startTime: s.startTime.toDate(),
            endTime: s.endTime.toDate(),
            id: s.id,
        }));
export const selectSchedulesIsLoading = (state: AppState): boolean => state.chatScheduleReducer.isLoading;
export const selectSchedulesIsSaving = (state: AppState): boolean => state.chatScheduleReducer.isSaving;
export const selectSchedulesError = (state: AppState): string | undefined => state.chatScheduleReducer.error;
